export enum SpotLightEnum {
    PercentChange = "% change",
    Mean = "mean",
    AbsoluteChange = "absolute-change",
    SampleSize = "sample-size",
    MeasureValue = "measure-value",
}

export * from "./form-fields.enum";
export * from "./tabs-key.enum";
export * from "./params.enum";
